// extracted by mini-css-extract-plugin
export default {"DropDownFilters":"DropDownFilters_DropDownFilters__dh11B","DropDownFilters__filterItem":"DropDownFilters_DropDownFilters__filterItem__3qmhn"};